const CheckIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
      <g clip-path='url(#clip0_74492_408)'>
        <rect width='18' height='18' rx='9' fill='white' />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.00325 0C13.9729 0 18.0032 4.03029 18.0032 8.99996C18.0032 13.9696 13.9729 17.9999 9.00325 17.9999C4.03359 17.9999 0.0032959 13.9696 0.0032959 8.99996C0.0032959 4.03029 4.03359 0 9.00325 0ZM7.1343 11.9232L4.93089 9.71798C4.55551 9.34237 4.55543 8.72986 4.93089 8.35433C5.30643 7.97887 5.92166 7.98122 6.29447 8.35433L7.84786 9.90894L11.7122 6.04462C12.0877 5.66908 12.7003 5.66908 13.0758 6.04462C13.4513 6.42009 13.4508 7.03319 13.0758 7.40821L8.52855 11.9554C8.15355 12.3304 7.54043 12.331 7.16497 11.9554C7.15442 11.9449 7.14424 11.9341 7.1343 11.9232Z'
          fill='#8B5CF6'
        />
      </g>
      <defs>
        <clipPath id='clip0_74492_408'>
          <rect width='18' height='18' rx='9' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckIcon;
